import { useState, useCallback } from 'react';

import { useParams } from 'src/routes/hooks';

import { getParamValue, type UrlParams } from 'src/utils/url-data-params';

import { DEFAULT_SORT } from 'src/models/recipe/list/sort-config';

// ----------------------------------------------------------------------

export function useRecipeBrowseSort() {
  const params = useParams() as unknown as UrlParams;

  const [sortBy, setSortBy] = useState<string>(getParamValue(params, 'sortBy') ?? DEFAULT_SORT);

  const handleSortBy = useCallback((newValue: string) => {
    setSortBy(newValue);
  }, []);

  return {
    sortBy,
    handleSortBy,
  };
}

